import React from "react";

export const SubmitButton = props => <button type="submit" className="btn btn-main">{props.title}</button>
